import React, {useEffect, useState} from "react";
import axiosInstance from "../../api";
import {Box, Grid, Snackbar} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Spinner from "../../components/Spinner";
import AgentContactInfoEditTile from "./AgentContactInfoEditTile";
import {Alert} from "@material-ui/lab";
import {useHistory} from "react-router-dom";
import {MUIConfirmationDialog} from "../../utils/formUtils";
import {useUserContext} from "../../context/UserContext";
import AgentContactInfoEditTileGP from "./AgentContactInfoEditTileGP";

const useStyles = makeStyles({
    root: {
        minWidth: 275,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
});


const initDialogProp = {title:null, content:null, show:false, action:null, additionalAttributes:null};
export default function AgentContactInfoView(agentId) {
    const classes = useStyles();
    const history = useHistory();
    const [showSpinner, setShowSpinner] = useState(false);
    const [agentInformation, setAgentInformation] = useState({mailingAddress: {}, appointedCompanies: []});
    const [showEdit, setShowEdit] = useState(false);
    const [snackBarSettings, setSnackBarSettings] = useState({show:false, message:null, variant:'success'});
    const [eligibleCompanies, setEligibleCompanies] = useState([]);
    const [dialogProperties, setDialogueAttributes] = useState(Object.assign({},initDialogProp));
    const {user,dispatch} = useUserContext();

    useEffect(() => {
        loadAgentInfomationByAgentIdFromAPI();
        loadEligibleCompaniesFromAPI();
    }, [])

    const loadEligibleCompaniesFromAPI = () => {
        setShowSpinner(true);
        axiosInstance.get('agents/all-fma-eligible-companies', {params: agentId}).then((data) => {
            data = data.map(item => {
                return {label: item['companyName'], value: item['eligibleCompanyId']}
            })
            setEligibleCompanies(data)
        }).finally(() => setShowSpinner(false))
    }
    const loadAgentInfomationByAgentIdFromAPI = () => {
        setShowSpinner(true);
        axiosInstance.post('search/get-agents-by-critieria', agentId).then((data) => {
            setAgentInformation(data?.resultList[0])
        }).catch(() => {
            //TODO: Show error message
        }).finally(() => {
            setShowSpinner(false);
        })
    }

    const onSuccessfulUpdate = () => {
        setShowEdit(false);
        loadAgentInfomationByAgentIdFromAPI();
        setSnackBarSettings({show: true, message: 'Agent Information updated successfully!', variant: 'success'});
    }

    const handleSnackBarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackBarSettings({show:false, message:null, variant:''});
    };

    const handleAgentWithdraw = () => {
        setDialogueAttributes({title:'Withdraw Lead', content:'By clicking YES, your FMAP account will be withdrawn, and you will be logged out.', show:true, action:'WITHDRAW', additionalAttributes: {}});
    }

    function handleDClose() {
        setDialogueAttributes(Object.assign({},initDialogProp));
    }

    function handleDConfirm() {
        setShowSpinner(true);
        axiosInstance.post('agents/withdraw-agent', {
            agentId: agentId.agentId,
            participantId: agentInformation?.participantId,
            personId: agentInformation?.personId,
            userRole: user.fmapRole
        })
            .then(() => {
                setSnackBarSettings({show: true, message: 'Agent withdrawn successfully!', variant: 'success'});
                if(user.fmapRole === "FMAP_AGENT"){
                    history.push('/logout/1');
                }
            })
            .catch(() => {
                setSnackBarSettings({
                    show: true,
                    message: 'An error occured while withdrawing the Agent. Please try again later.',
                    variant: 'error'
                });
            })
            .finally(() => setShowSpinner(false));
        setDialogueAttributes(Object.assign({},initDialogProp));
    }

    if (showSpinner) return <Spinner/>

    return <>
        <section>
            {!showEdit && <Box m={3}>
                <Typography variant="h5" component="h2">
                    Agent Contact Information
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4}>
                        DFS License#: <br/>
                        <b>{agentInformation?.dfsLicense}</b>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        Social Security Number: <br/>
                        <b>On File</b>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4}>
                        Full Name: <br/> <b>{agentInformation?.firstName + ' ' + agentInformation?.lastName}</b>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        Agency: <br/> <b>{agentInformation?.agencyName}</b>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        Email: <br/> <b> <a href={`mailto:${agentInformation?.email}`}
                                            target="_top">{agentInformation?.email}</a></b>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4}>
                        Primary Phone: <br/><b>
                        {agentInformation?.workPhone ?
                            <a href={`tel:${agentInformation?.workPhone}`}
                               target="_top">{agentInformation?.workPhone}</a>
                            : 'n/a'
                        }</b>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        Alternate Phone: <br/><b>
                        {agentInformation?.mobile ?
                            <a href={`tel:${agentInformation?.mobile}`}
                               target="_top">{agentInformation?.mobile}</a>
                            : 'n/a'
                        }
                        </b>
                    </Grid>
                    {/*<Grid item xs={12} sm={6} md={4}>*/}
                    {/*    Fax: <br/><b>*/}
                    {/*    {agentInformation?.fax ?*/}
                    {/*        <a href={`tel:${agentInformation?.fax}`} target="_top">{agentInformation?.fax}</a>*/}
                    {/*        : 'n/a'*/}
                    {/*    }</b>*/}
                    {/*</Grid>*/}
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4}>
                        Mailing Address: <br/>
                        <b>
                            {agentInformation?.mailingAddress?.addressLine1}
                            {agentInformation?.mailingAddress?.addressLine2 &&
                            <><br/>{agentInformation?.mailingAddress?.addressLine2}</>} <br/>
                            {agentInformation?.mailingAddress?.city}, {agentInformation?.mailingAddress?.state}&nbsp;{agentInformation?.mailingAddress?.zip}
                            <br/>
                            {agentInformation?.mailingAddress?.county} County, {agentInformation?.mailingAddress?.country}
                        </b>
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item md={12}>
                        Appointed With: <br/>
                        <b>
                            <ul style={{columnCount: 3}}>
                                {eligibleCompanies.map(item => <li
                                    style={{marginLeft: '20px'}}> {item.label} </li>)}
                            </ul>
                        </b>
                    </Grid>
                </Grid>
                <Box component="span" justifyContent="flex-start" alignItems="flex-start" display="flex">
                    <Button size="small" color="primary" variant="contained" onClick={() => setShowEdit(true)}>Edit</Button> &nbsp;
                    <Button size="small" color="primary" variant="contained" onClick={handleAgentWithdraw}>Withdraw</Button>
                </Box>
            </Box>}
            <br/>
            {showEdit && <AgentContactInfoEditTileGP agentInformation={agentInformation} setShowEdit={setShowEdit} agentId={agentId} onSuccessfulUpdate={onSuccessfulUpdate}/>}
            <Snackbar open={snackBarSettings.show} autoHideDuration={6000} onClose={handleSnackBarClose}>
                <Alert variant="filled" onClose={handleSnackBarClose} severity={snackBarSettings.variant}>{snackBarSettings.message}</Alert>
            </Snackbar>

            <MUIConfirmationDialog dialogTitle={dialogProperties.title}
                                   dialogContent={dialogProperties.content}
                                   showDialog={dialogProperties.show} handleDialogClose={handleDClose}
                                   handleUserConfirmation={handleDConfirm}></MUIConfirmationDialog>
        </section>
    </>
}
